<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="680px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="80px"
        :label-position="labelPosition"
      >
          <el-form-item label="背景图:" prop="img">
            <base-upload
              class="upload"
              :cover="params.img"
              :key="params.portrait"
              :action="action"
              :wSize="180"
              :hSize="90"
              v-if="showImg"
              :width="'180px'"
              :height="'90px'"
              @successCallback="handleAvatarSuccess"
            ></base-upload>
          </el-form-item>

          <el-form-item
            label="特权:"
            prop="privilegeName"
          >
            <el-input
              v-model="params.privilegeName"
              size="small"
              style="width: 240px;"
              placeholder="请输入特权"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="特权描述:"
            prop="privilegeName"
          >
            <el-input
              v-model="params.privilegeDesc"
              size="small"
              style="width: 240px;"
              placeholder="请输入特权描述"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="排序:"
            prop="sort"
          >
            <el-input
              v-model="params.sort"
              size="small"
              style="width: 240px;"
              placeholder="请输入当前排序"
            ></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'
import {validatorIndex} from '@/utils/validator'

export default {
  data() {
    return {
      showImg: false,
      labelPosition: 'left',
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      type: '',
      action: baseConfig.baseServerUrl + '/agent/upload/static',

      positionTypeList: [],

      params: {
        id: '',
        img: '',
        privilegeDesc: '',
        privilegeName: '',
        sort: 0,
        status: true,
      },
      rules: {
        productName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        duration: [
          { pattern: /^(0|\+?[1-9][0-9]{0,4})$/, message: '最大不能超过99999', trigger: 'blur' },
        ],
        originalPrice: [
          { required: true, message: '请输入原价', trigger: 'blur' },
          { validator: validatorIndex, trigger: 'blur' },
        ],
        discountedPriceIos: [
          { required: true, message: '请输入IOS现价', trigger: 'blur' },
          { validator: validatorIndex, trigger: 'blur' },
        ],
        discountedPriceAnd: [
          { required: true, message: '请输入安卓现价', trigger: 'blur' },
          { validator: validatorIndex, trigger: 'blur' },
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { validator: validatorIndex, trigger: 'blur' },
        ],
        goldVideoFreeDay: [
          { pattern: /^(0|\+?[1-9][0-9]{0,4})$/, message: '最大不能超过99999', trigger: 'blur' }
        ],
        position: [{ required: true, message: '请选择产品位置', trigger: 'blur' }],
        timesAWeek: [{ required: true, message: '请输入每周可领次数', trigger: 'blur' }],
        louFengDiscount: [{ required: true, message: '请输入楼凤折扣率', trigger: 'blur' }],
      },
    }
  },
  methods: {
    //获取产品位置

    // 表单验证提交
    submitForm() {
      this.params.sort = this.params.sort ? Number(this.params.sort) : 0
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.type === 'add') {
            this.addProduct()
          }
          if (this.type === 'edit') {
            this.editProduct()
          }
        } else {
          return false
        }
      })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.showImg = false
      this.params = {
        productName: '',
        desc: '',
        duration: '',
        originalPrice: '',
        discountedPrice: '',
        sort: 0,
        status: false,
        unitPriceDisplay: false,
        vipLevel: '',
        bgImg: '',
        position: '',
        actionDesc: '',
        privilegeDesc: '',
        showCountdownTime: '',
        isAmountPay: '',
        productType: '',
        timesAWeek: undefined,
        louFengDiscount: undefined,
        giveCoin: ''
      }
      this.$refs['form'].resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.showImg = true
      this.type = type
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑VIP权益商品'
        this.params = { ...data }
        this.id = data.id
      } else {
        this.title = '新增VIP权益商品'
      }
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
        this.params.img = res.data.coverImg
        this.$forceUpdate()
      // this.params.img = res.data.coverImg
    },

    // 新增商品
    addProduct() {
      API.addPrivilege(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success',
            })
            this.$emit('handlerProductList')
          } else {
            this.$message.error('添加失败')
          }
          this.handleClose()
          this.flag = false
        })
        .catch(() => {
          this.handleClose()
          this.flag = false
        })
    },
    // 编辑商品
    editProduct() {

      API.editProduct(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '编辑成功',
              type: 'success',
            })
            this.$emit('handlerProductList')
          } else {
            this.$message.error('编辑失败')
          }
          this.handleClose()
          this.flag = false
        })
        .catch(() => {
          this.handleClose()
          this.flag = false
        })
    },
  },
}
</script>

<style lang="scss" >
.add-pay-box {
  .el-input {
    width: 150px;
  }
  .flex-item {
    width: 90%;
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
    .item-box {
      display: flex;
      flex-direction: column;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .privileges .el-input--suffix {
    width: 480px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
